import { render } from "./EOIInfoMessage.vue?vue&type=template&id=ff720266&scoped=true&ts=true&lang=pug"
import script from "./EOIInfoMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EOIInfoMessage.vue?vue&type=script&lang=ts&setup=true"

import "./EOIInfoMessage.vue?vue&type=style&index=0&id=ff720266&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff720266"]])

export default __exports__